import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { StorageAdapter } from './types';
import { BrowserStorageAdapter } from './browser';
import { LocalFsStorageAdapter } from './local-fs';

interface StorageState {
  browserAdapter: BrowserStorageAdapter;
  localAdapter: LocalFsStorageAdapter | null;
  recent: Array<{ kind: 'cloud' | 'local' | 'browser'; storageRef: string; name: string; updatedAt: string }>;
  setLocalAdapter: (a: LocalFsStorageAdapter | null) => void;
  pushRecent: (entry: { kind: 'cloud' | 'local' | 'browser'; storageRef: string; name: string; updatedAt: string }) => void;
}

export const useStorage = create<StorageState>()(
  persist(
    (set) => ({
      browserAdapter: new BrowserStorageAdapter(),
      localAdapter: null,
      recent: [],
      setLocalAdapter(a) {
        set({ localAdapter: a });
      },
      pushRecent(entry) {
        set((s) => ({
          recent: [
            entry,
            ...s.recent.filter((r) => !(r.kind === entry.kind && r.storageRef === entry.storageRef)),
          ].slice(0, 20),
        }));
      },
    }),
    {
      name: 'archer.storage',
      partialize: (s) => ({ recent: s.recent }),
    },
  ),
);

export const getStorageAdapter = (
  kind: 'cloud' | 'local' | 'browser',
  cloud?: StorageAdapter,
): StorageAdapter => {
  const state = useStorage.getState();
  if (kind === 'cloud') {
    if (!cloud) throw new Error('cloud storage not available (not signed in)');
    return cloud;
  }
  if (kind === 'local') {
    if (!state.localAdapter) throw new Error('no local folder selected');
    return state.localAdapter;
  }
  return state.browserAdapter;
};
